// libs
import React, { memo, useEffect, useMemo, useState } from 'react';

//components
import ShopAllCheckbox from 'shared/components/Filter/components/ShopAllCheckbox';

//styles
import {
  CategoryList,
  Option,
  RightArrow,
  OptionInfo,
  Title,
  Count,
  FilterCheckbox,
} from './styles';

//helpers
import { getAllIds } from './helpers';

//defs
import { Value } from 'shared/components/Filter/types';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

interface CategoryPopUpProps {
  values: Value[];
  selectedOptions: string[];
  onValueSelection: (item: string) => void;
  onShopAllClick: (items: string[], isAllSelected: boolean) => void;
  level?: string;
  showSelectAll?: boolean;
  allProductCount?: number;
}

const ARROW_SIZE = '18px';

function CategoryPopUp({
  values,
  selectedOptions,
  onValueSelection,
  onShopAllClick,
  level = '0',
  showSelectAll = false,
  allProductCount = 0,
}: CategoryPopUpProps) {
  const [selectedValue, setSelectedValue] = useState<Value>();
  const ChevronRightIcon = useStoreIcon(IconName.CHEVRON_RIGHT_SMALL);

  const { allIDs, isAllSelected } = useMemo(() => {
    const _allIDs = getAllIds(values);
    const _isAllSelected = !_allIDs.some((val) => selectedOptions.indexOf(val) === -1);
    return { allIDs: _allIDs, isAllSelected: _isAllSelected };
  }, [selectedOptions, values]);

  useEffect(() => {
    if (selectedValue && values[0].parent_id !== selectedValue.parent_id)
      setSelectedValue(undefined);
  }, [selectedValue, values]);

  return (
    <>
      <CategoryList level={level}>
        {showSelectAll && (
          <ShopAllCheckbox
            onShopAllClick={() => onShopAllClick(allIDs, isAllSelected)}
            allProductCount={allProductCount}
            isChecked={isAllSelected}
          />
        )}

        {values.map((value) => {
          const { id, name, productCount } = value;
          if (value.children?.length) {
            return (
              <Option
                onClick={() => setSelectedValue(value)}
                key={`filter-${id}`}
                isSelected={selectedValue?.id === id}
              >
                <OptionInfo>
                  <Title title={name}>{name}</Title>
                  <Count>{productCount}</Count>
                </OptionInfo>
                <RightArrow>
                  <ChevronRightIcon size={ARROW_SIZE} />
                </RightArrow>
              </Option>
            );
          } else {
            return (
              <FilterCheckbox
                key={`filter-${id}`}
                value={value}
                isSelected={selectedOptions.includes(id)}
                onFilterSelection={onValueSelection}
              />
            );
          }
        })}
      </CategoryList>

      {selectedValue?.id && (
        <CategoryPopUp
          level={selectedValue.level}
          values={selectedValue.children}
          selectedOptions={selectedOptions}
          onValueSelection={onValueSelection}
          showSelectAll={selectedValue.show_select_all}
          allProductCount={selectedValue.productCount}
          onShopAllClick={onShopAllClick}
        />
      )}
    </>
  );
}

export default memo(CategoryPopUp);
